import React from "react";
import terms from "./terms-data";

const OffersFooter = () => (
  <div id="offers-footer">
    <i className="fas fa-info-circle" /> {terms}
  </div>
);

export default OffersFooter;
